module.exports = __webpack_public_path__ + "static/media/misforstå.383a774e.m4a";